const en = {
  // Common
  save: 'Save',
  cancel: 'Cancel',
  delete: 'Delete',
  edit: 'Edit',
  add: 'Add',
  search: 'Search',
  filter: 'Filter',
  export: 'Export',
  import: 'Import',
  loading: 'Loading...',
  noData: 'No data',
  confirm: 'Confirm',
  back: 'Back',
  close: 'Close',
  yes: 'Yes',
  no: 'No',
  all: 'All',
  active: 'Active',
  inactive: 'Inactive',
  status: 'Status',
  actions: 'Actions',
  name: 'Name',
  email: 'Email',
  password: 'Password',
  value: 'Value',
  date: 'Date',
  description: 'Description',
  type: 'Type',

  // Currency
  currency: 'USD',
  currencyLocale: 'en-US',
  currencySymbol: '$',
  dateLocale: 'en-US',

  // Sidebar
  sidebar: {
    principal: 'Main',
    dashboard: 'Dashboard',
    giftCards: 'Gift Cards',
    suppliers: 'Suppliers',
    transactions: 'Transactions',
    reports: 'Reports',
    admin: 'Administration',
    users: 'Users',
    adminPanel: 'Admin Panel',
    settings: 'Settings',
    darkMode: 'Dark Mode',
    lightMode: 'Light Mode',
    administrator: 'Administrator',
    operator: 'Operator',
    logout: 'Sign Out',
    help: 'Help',
    blog: 'Blog',
    integrations: 'Integrations',
  },

  // Dashboard
  dashboard: {
    title: 'Dashboard',
    goodMorning: 'Good morning',
    goodAfternoon: 'Good afternoon',
    goodEvening: 'Good evening',
    totalCards: 'Total Cards',
    activeCards: 'Active Cards',
    availableBalance: 'Available Balance',
    totalSavings: 'Total Savings',
    expiring: 'Expiring',
    noCardsExpiring: 'No cards expiring',
    recentActivity: 'Recent Activity',
    last10: 'Last 10',
    noActivity: 'No activity',
    movementBySupplier: 'Movement by Supplier',
    bars: 'Bars',
    line: 'Line',
    portfolioDistribution: 'Portfolio Distribution',
    summaryBySupplier: 'Summary by Supplier',
    cards: 'cards',
    daysRemaining: 'days remaining',
    expired: 'Expired!',
    urgent: 'Urgent',
    monthlyComparison: 'Monthly Comparison',
    dailyBalance: 'Daily Balance',
    purchases: 'Purchases',
    uses: 'Uses',
    returns: 'Returns',
    adjustments: 'Adjustments',
    totalPurchases: 'Total Purchases',
    totalUses: 'Total Uses',
    totalReturns: 'Total Returns',
    totalMoved: 'Total Moved',
    highest: 'Highest',
    lowest: 'Lowest',
    variation: 'Variation',
    noPeriodData: 'No data for the period',
    noDataAvailable: 'No data available',
    noDataForMonth: 'No data for selected month',
    discountSavings: 'Savings from Discounts',
    discountSavingsDesc: 'Total saved by buying gift cards at a discount',
    cardsSaved: 'Cards Fully Used',
    cardsSavedDesc: 'Cards fully used before their expiration date',
  },

  // Transaction types
  transactionTypes: {
    COMPRA: 'Purchase',
    USO: 'Usage',
    AJUSTE: 'Adjustment',
    RETURN: 'Return',
  },

  // Gift Card statuses
  giftCardStatus: {
    ATIVO: 'Active',
    PARCIAL: 'Partial',
    ZERADO: 'Depleted',
    EXPIRADO: 'Expired',
    CANCELADO: 'Cancelled',
    all: 'All Statuses',
  },

  // Gift Cards page
  giftCards: {
    title: 'Gift Cards',
    subtitle: 'Manage your gift cards',
    newCard: 'New Gift Card',
    code: 'Code',
    supplier: 'Supplier',
    initialValue: 'Initial Value',
    currentValue: 'Current Value',
    discount: 'Discount',
    paidValue: 'Paid Value',
    cardNumber: 'Card Number',
    pin: 'PIN',
    purchaseOrder: 'Purchase Order',
    purchaseDate: 'Purchase Date',
    expirationDate: 'Expiration Date',
    buyer: 'Buyer',
    purchaseSite: 'Purchase Site',
    duplicateCardNumber: 'A gift card with this card number already exists in your account.',
    noCards: 'No gift cards found',
    grid: 'Grid',
    table: 'Table',
    usageValue: 'Usage Value',
    usedValue: 'Amount Used',
    useAll: 'Use All',
    useFullBalance: 'Use Full Balance',
    giftCardValue: 'Gift Card Value',
    sortOptions: {
      availableFirst: 'Available first',
      supplierAZ: 'Supplier A-Z',
      supplierZA: 'Supplier Z-A',
      highestValue: 'Highest value',
      lowestValue: 'Lowest value',
      newest: 'Newest',
      oldest: 'Oldest',
    },
    bulkImport: 'Bulk Import',
    bulkImportDesc: 'Import multiple gift cards at once from a CSV file.',
    downloadTemplate: 'Download CSV Template',
    downloadTemplateDesc: 'Download an empty CSV file with the required columns. Fill it with your gift card data and upload it below.',
    uploadCSV: 'Upload CSV File',
    uploadCSVDesc: 'Select the filled CSV file to import your gift cards.',
    importing: 'Importing...',
    importBtn: 'Import Cards',
    imported: 'Imported',
    importError: 'Import error',
    row: 'Row',
    selectFile: 'Select a CSV file',
    adminOnlyImport: 'Only administrators can import cards.',
    paidPlanOnly: 'Bulk import is available on Starter and Pro plans.',
    templateColumns: 'Template columns: supplier, site, buyer, value, discount, paid_value, balance, card_number, pin, purchase_order, purchase_date, expiration_date',
  },

  // Suppliers page
  suppliers: {
    title: 'Suppliers',
    subtitle: 'Manage gift card suppliers',
    mySuppliers: 'My Suppliers',
    manageSuppliers: 'Manage Suppliers',
    customSuppliers: 'Custom Suppliers',
    newSupplier: 'New Supplier',
    website: 'Website',
    defaultDiscount: 'Default Discount',
    totalCards: 'Total Cards',
    activeCards: 'Active Cards',
    available: 'Available',
    invested: 'Invested',
    noSuppliers: 'No suppliers found',
    editSupplier: 'Edit Supplier',
    addSupplier: 'Add Supplier',
    deactivate: 'Deactivate',
    activate: 'Activate',
  },

  // Transactions page
  transactions: {
    title: 'Transactions',
    subtitle: 'Transaction history',
    newTransaction: 'New Transaction',
    usage: 'Usage',
    adjustment: 'Adjustment',
    return: 'Return',
    value: 'Value',
    orderNumber: 'Order Number',
    user: 'User',
    noTransactions: 'No transactions found',
  },

  // Reports page
  reports: {
    title: 'Reports',
    subtitle: 'Analytics and reports',
    bySupplier: 'By Supplier',
    byBuyer: 'By Buyer',
    exportCSV: 'Export CSV',
    totalFaceValue: 'Total Face Value',
    totalInvested: 'Total Invested',
    totalAvailable: 'Total Available',
    savings: 'Savings',
    avgDiscount: 'Avg. Discount',
  },

  // Users page
  users: {
    title: 'Users',
    subtitle: 'Manage system users',
    newUser: 'New User',
    inviteUser: 'Invite User',
    sendInvite: 'Send Invite',
    sending: 'Sending...',
    inviteSent: 'Invitation sent! They will receive an email to set their password.',
    inviteResent: 'Invite email resent!',
    inviteHint: 'An email will be sent with a link to set their password and access the dashboard.',
    resendInvite: 'Resend invite email',
    role: 'Role',
    name: 'Name',
    namePlaceholder: 'Full name',
    emailLabel: 'Email',
    activeLabel: 'Active',
    inactiveLabel: 'Inactive',
    totalUsers: 'Total Users',
    registered: 'registered users',
    administrators: 'Administrators',
    admin: 'Administrator',
    adminDesc: 'Full access',
    operator: 'Operator',
    operatorDesc: 'Standard access',
    noUsers: 'No users found',
    editUser: 'Edit User',
    deactivate: 'Deactivate',
    activate: 'Activate',
    deactivated: 'User deactivated',
    activated: 'User activated',
    pendingSetup: 'Pending setup',
    cannotDeactivateSelf: 'Cannot deactivate your own user',
    errorLoading: 'Error loading users',
    errorUpdating: 'Error updating user',
  },

  // Settings page
  settings: {
    title: 'Settings',
    subtitle: 'Account and plan management',
    planUpgrade: 'Plan & Upgrade',
    paymentHistory: 'Payment History',
    accountImport: 'Account & Import',
    currentPlan: 'Current Plan',
    planUsage: 'Plan Usage',
    users: 'Users',
    customSuppliers: 'Custom Suppliers',
    perMonth: '/month',
    free: 'Free',
    currentPlanBtn: 'Current plan',
    upgrade: 'Upgrade',
    change: 'Change',
    processing: 'Processing...',
    activeSubscription: 'Active Subscription',
    invoices: 'Invoices',
    noInvoices: 'No invoices found',
    invoiceDate: 'Date',
    invoiceDescription: 'Description',
    invoiceAmount: 'Amount',
    invoiceStatus: 'Status',
    invoicePeriod: 'Period',
    accountInfo: 'Account Information',
    account: 'Account',
    user: 'User',
    profile: 'Profile',
    plan: 'Plan',
    createdAt: 'Created at',
    importCSV: 'Import CSV',
    importDesc: 'Import gift cards from a CSV file. Columns: supplier, site, buyer, value, discount, paid_value, balance, card_number, pin, purchase_order, purchase_date, expiration.',
    importBtn: 'Import',
    importing: 'Importing...',
    adminOnly: 'Only administrators can import.',
    system: 'System',
    version: 'Version',
    language: 'Language',
    languageDesc: 'Choose the system language',
    confirmUpgrade: 'Confirm change to plan',
    currentLabel: 'CURRENT',
    unlimited: 'Unlimited',
    manageSubscription: 'Manage Subscription',
    selectFile: 'Select a CSV file',
    imported: 'Imported',
    row: 'Row',
    loadError: 'Error loading account data',
    loadHistoryError: 'Error loading history',
    upgradeError: 'Error upgrading plan',
    importError: 'Import error',
    portalError: 'Error opening billing portal',
    timezone: 'Timezone',
    timezoneDesc: 'Set your preferred timezone for date and time display. This setting is personal and saved to your browser.',
    currentTime: 'Current time',
    useStripeMsg: 'Please use Stripe Checkout for paid plans.',
    changePassword: 'Change Password',
    currentPassword: 'Current Password',
    newPassword: 'New Password',
    confirmPassword: 'Confirm Password',
    updatePassword: 'Update Password',
    passwordChanged: 'Password updated successfully',
    passwordChangeError: 'Error changing password',
    passwordMismatch: 'Passwords do not match',
    passwordTooShort: 'Password must be at least 8 characters',
    changeEmail: 'Change Email',
    newEmail: 'New Email',
    confirmWithPassword: 'Confirm with Password',
    updateEmail: 'Update Email',
    emailChanged: 'Email updated successfully',
    emailChangeError: 'Error changing email',
    changeEmailDesc: 'Enter your new email and current password to confirm.',
    fillAllFields: 'Please fill all fields',
    security: 'Security',
    twoFactorTitle: 'Two-Factor Authentication',
    currentMethod: 'Current method',
    emailOtp: 'Email OTP',
    totpEnabled: 'Google Authenticator (TOTP)',
    enableTotp: 'Enable Google Authenticator',
    disableTotp: 'Disable Google Authenticator',
    totpActive: 'Google Authenticator is active',
    scanQR: 'Scan this QR code with Google Authenticator:',
    manualKey: 'Or manually enter this key:',
    enterCode: 'Enter the 6-digit code from the app to verify:',
    totpEnabledSuccess: 'TOTP enabled successfully!',
    totpDisabledSuccess: 'TOTP disabled. Email OTP will be used.',
    loginHistory: 'Login History',
    loginHistoryDesc: 'Recent login activity on your account',
    loginDate: 'Date',
    loginAction: 'Event',
    loginIP: 'IP Address',
    loginDevice: 'Device',
    noLoginHistory: 'No login history found',
    sessions: 'Active Sessions',
    sessionsDesc: 'Manage your active login sessions',
    revokeAllSessions: 'Revoke All Sessions',
    revokeAllSessionsConfirm: 'This will log you out of all devices. Continue?',
    sessionsRevoked: 'All sessions revoked. Please log in again.',
    revokeError: 'Error revoking sessions',
    support: 'Support',
    downgradeWarning: 'Downgrade Warning',
    downgradeWillLose: 'Downgrading may affect your data:',
    downgradeUsers: 'Extra users beyond the plan limit will be deactivated',
    downgradeCards: 'You won\'t be able to add new cards beyond the plan limit',
    downgradeSuppliers: 'Extra custom suppliers beyond the plan limit will be deactivated',
    confirmDowngrade: 'I understand, downgrade anyway',
    cancelSubscription: 'Cancel Subscription',
    cancelSubscriptionDesc: 'Cancel your paid subscription. Your data will be preserved but you\'ll move to the Free plan.',
    cancelSubscriptionBtn: 'Cancel Subscription',
    cancelReasonTitle: 'We\'re sorry to see you go. What\'s the main reason?',
    cancelTooExpensive: 'Too expensive',
    cancelMissingFeatures: 'Missing features I need',
    cancelFoundAlternative: 'Found an alternative',
    cancelNoLongerNeeded: 'No longer need it',
    cancelJustTesting: 'Was just testing',
    cancelOther: 'Other',
    continueCancel: 'Continue',
    nevermind: 'Never mind',
    offerTitle: 'Before you go...',
    feedbackTitle: 'We appreciate your feedback',
    keepSubscription: 'Keep my subscription',
    proceedCancel: 'Cancel anyway',
    goBack: 'Go back',
    selectReason: 'Please select a reason',
    gladYouStayed: 'Glad you\'re staying!',
  },

  // Legal footer links
  legal: {
    terms: 'Terms of Service',
    privacy: 'Privacy Policy',
    cookies: 'Cookie Policy',
    cookieBanner: 'We use cookies to keep you logged in and, with your consent, to improve the product with anonymous analytics.',
    acceptAll: 'Accept All',
    rejectOptional: 'Reject Optional',
    managePreferences: 'Manage Preferences',
    savePreferences: 'Save Preferences',
    essential: 'Essential',
    essentialDesc: 'Authentication tokens, language & theme preferences. Required for the app to work.',
    analytics: 'Analytics',
    analyticsDesc: 'Anonymous usage data via PostHog. Helps us understand which features are used most. No personal data is shared.',
    alwaysOn: 'Always On',
  },

  // Plan names
  plans: {
    FREE: { name: 'Free', desc: 'To get started' },
    STARTER: { name: 'Starter', desc: 'For growing teams' },
    PRO: { name: 'Pro', desc: 'Unlimited everything' },
  },

  // Status labels
  statusLabels: {
    active: 'Active',
    canceled: 'Canceled',
    past_due: 'Overdue',
    paid: 'Paid',
    pending: 'Pending',
    failed: 'Failed',
  },

  // Login
  login: {
    title: 'Welcome to CardLockr',
    subtitle: 'Sign in to your account',
    email: 'Email',
    password: 'Password',
    signIn: 'Sign In',
    signingIn: 'Signing in...',
    error: 'Invalid email or password',
    forgotPassword: 'Forgot password?',
  },

  // Forgot Password
  forgotPassword: {
    title: 'Forgot your password?',
    subtitle: "Enter your email and we'll send you a reset link.",
    send: 'Send Reset Link',
    sending: 'Sending...',
    success: 'If an account with that email exists, a reset link has been sent.',
    checkSpam: 'Check your inbox (and spam folder) for the reset link.',
    backToLogin: 'Back to Login',
  },

  // Reset Password
  resetPassword: {
    title: 'Reset Your Password',
    subtitle: 'Enter your new password below.',
    newPassword: 'New Password',
    confirmPassword: 'Confirm Password',
    reset: 'Reset Password',
    resetting: 'Resetting...',
    success: 'Password reset successfully!',
    error: 'Invalid or expired reset link',
    mismatch: 'Passwords do not match',
    tooShort: 'Password must be at least 8 characters',
    invalidToken: 'Invalid Reset Link',
    invalidTokenDesc: 'This password reset link is invalid or has expired.',
    requestNew: 'Request a New Link',
  },

  // 2FA Verification
  verify2FA: {
    title: 'Verify Your Identity',
    emailSubtitle: 'We sent a 6-digit code to your email.',
    totpSubtitle: 'Enter the code from your authenticator app.',
    verify: 'Verify',
    verifying: 'Verifying...',
    resend: 'Resend Code',
    resending: 'Resending...',
    resent: 'Code resent! Check your email.',
    invalidCode: 'Invalid verification code',
    didntReceive: "Didn't receive a code?",
    sessionExpired: 'Session expired. Please login again.',
    trustDevice: 'Trust this device for 30 days',
  },

  // Not Found page
  notFound: {
    title: 'Page Not Found',
    message: 'The page you are looking for doesn\'t exist or has been moved.',
    backHome: 'Go to Home',
  },

  // Admin Panel
  adminPanel: {
    title: 'Admin Panel',
    accountOverview: 'Account Overview',
    plan: 'Plan',
    accountAge: 'Account Age',
    days: 'days',
    planExpires: 'Plan Expires',
    neverExpires: 'Never',
    usage: 'Usage',
    users: 'Users',
    giftCards: 'Gift Cards',
    customSuppliers: 'Custom Suppliers',
    unlimited: 'Unlimited',
    of: 'of',
    systemHealth: 'System Health',
    database: 'Database',
    emailService: 'Email Service',
    encryption: 'Encryption',
    authentication: 'Authentication',
    payments: 'Payments',
    monitoring: 'Monitoring',
    configured: 'Configured',
    notConfigured: 'Not Configured',
    connected: 'Connected',
    disconnected: 'Disconnected',
    uptime: 'Uptime',
    environment: 'Environment',
    securityOverview: 'Security Overview',
    twoFAAdoption: '2FA Adoption',
    failedLogins24h: 'Failed Logins (24h)',
    activeUsers: 'Active Users',
    totalUsers: 'Total Users',
    teamMembers: 'Team Members',
    role: 'Role',
    status: 'Status',
    twoFA: '2FA',
    cards: 'Cards',
    txns: 'Txns',
    joined: 'Joined',
    enabled: 'Enabled',
    disabled: 'Disabled',
    recentLogins: 'Recent Login Activity',
    recentTransactions: 'Recent Transactions',
    noLogins: 'No login activity yet',
    noTransactions: 'No transactions yet',
    cardsSummary: 'Cards Summary',
    totalValue: 'Total Value',
    currentValue: 'Current Value',
    totalSavings: 'Total Savings',
    totalInvested: 'Total Invested',
    optional: 'optional',
    emailOtp: 'Email OTP',
    allUsers: 'All users',
    totpUsers: 'TOTP (Authenticator)',
  },

  // Onboarding Tour
  tour: {
    welcomeTitle: 'Welcome to CardLockr!',
    welcomeDesc: 'Your platform for managing gift cards with total control. Let us show you around in a few quick steps.',
    dashboardTitle: 'Dashboard',
    dashboardDesc: 'Your command center. See total cards, available balance, savings, charts, and recent activity at a glance.',
    suppliersTitle: 'Suppliers',
    suppliersDesc: 'Activate built-in suppliers like Amazon, Walmart, Target, or create your own custom suppliers.',
    giftCardsTitle: 'Gift Cards',
    giftCardsDesc: 'Add, view, and manage all your gift cards. Track values, discounts, expiration dates, and balances.',
    transactionsTitle: 'Transactions',
    transactionsDesc: 'Record purchases, usage, adjustments, and returns. Keep a complete history of every card movement.',
    reportsTitle: 'Reports',
    reportsDesc: 'Analyze your portfolio by supplier or buyer. Export data to CSV for external analysis.',
    settingsTitle: 'Settings',
    settingsDesc: 'Manage your plan, import cards via CSV, change password, enable 2FA, and customize your experience.',
    readyTitle: "You're All Set!",
    readyDesc: 'Start by activating your suppliers, then add your first gift card. You can always access Help from the sidebar.',
    skip: 'Skip tour',
    next: 'Next',
    start: "Let's go!",
  },

  // Help Center
  help: {
    title: 'Help Center',
    heroTitle: 'How can we help you?',
    heroDesc: 'Learn everything about CardLockr — from getting started to advanced features. Choose a topic below.',
    overview: 'Overview',
    howTo: 'How To',
    features: 'Features',
    faq: 'FAQ',
    shortcuts: 'Shortcuts',

    whatIs: 'What is CardLockr?',
    whatIsDesc: 'CardLockr is a secure gift card management platform designed for individuals and teams who buy gift cards at a discount. Think of it as a digital vault for your gift card portfolio — it keeps all your card numbers and PINs encrypted, tracks balances automatically as you use them, and shows you exactly how much you\'re saving. Whether you manage 10 cards or 10,000, CardLockr helps you stay organized and never lose track of a dollar.',
    overviewTip: 'Your Dashboard is the first thing you see after logging in. It shows your total portfolio value, active cards, savings, and any cards expiring soon — all at a glance.',
    mainFeatures: 'Main Features',
    feat1Title: 'Gift Card Management',
    feat1Desc: 'Store, organize and track all your gift cards in one place. Card numbers and PINs are encrypted with military-grade AES-256 encryption. Click to copy card numbers and PINs instantly.',
    feat2Title: 'Supplier Management',
    feat2Desc: 'Choose from 30+ built-in suppliers (Walmart, Target, Amazon...) or create custom ones. Set a personal discount rate for each supplier that auto-fills when you add cards.',
    feat3Title: 'Transaction Tracking',
    feat3Desc: 'Record every purchase, usage, adjustment and return. Balances update automatically and every change is logged in the audit trail.',
    feat4Title: 'Reports & Analytics',
    feat4Desc: 'See your portfolio broken down by supplier or buyer. Track face value, invested amount, available balance, total savings, and average discount.',
    feat5Title: 'Security',
    feat5Desc: 'AES-256 encryption for all card data, two-factor authentication (email code + Google Authenticator), login history monitoring, and session management.',
    feat6Title: 'Team Collaboration',
    feat6Desc: 'Invite team members with Admin or Operator roles. Admins can manage everything; Operators can add/use cards but can\'t change account settings.',

    plans: 'Plans & Pricing',
    plansDesc: 'CardLockr offers three plans. Start free and upgrade as you grow:',
    freePlan: 'Free — $0/mo',
    freePlanDesc: 'Up to 10 cards, 1 user, and 3 custom suppliers. Perfect to try CardLockr and see if it fits your workflow.',
    starterPlan: 'Starter — $9.90/mo',
    starterPlanDesc: 'Up to 100 cards, 3 users, 10 custom suppliers, CSV import, and basic reports. Great for growing teams.',
    proPlan: 'Pro — $24.90/mo',
    proPlanDesc: 'Unlimited cards, users, and suppliers. Charts, PDF export, TOTP 2FA, API access, webhooks, and priority support.',

    // How To — Getting Started
    howGettingStarted: 'Getting Started (First Time Setup)',
    howGS1: 'Create your account',
    howGS1d: 'Go to cardlockr.com and click "Get Started Free". Enter your name, email, and password. You\'ll receive a welcome email with tips to get the most out of CardLockr.',
    howGS2: 'Activate your suppliers',
    howGS2d: 'After logging in, go to the Suppliers page from the sidebar. You\'ll see 30+ popular suppliers like Walmart, Target, and Amazon. Click the toggle switch next to each supplier you buy gift cards from to activate them.',
    howGS3: 'Add your first gift card',
    howGS3d: 'Go to Gift Cards and click the "+" button. Select the supplier, enter the card value, discount percentage, card number, and PIN. CardLockr will encrypt everything and calculate how much you saved.',
    howGS4: 'Set up security (recommended)',
    howGS4d: 'Go to Settings > Security and enable two-factor authentication. This adds an extra layer of protection — every time you log in, you\'ll need to enter a code from your email or Google Authenticator app.',
    howGSTip: 'You can start using CardLockr in under 2 minutes. Just activate your suppliers and add your first card — everything else you can explore at your own pace.',

    // How To — Suppliers
    howSuppliers: 'How to set up Suppliers',
    howSuppliers1: 'Go to Suppliers page',
    howSuppliers1d: 'Click "Suppliers" in the sidebar. You\'ll see two sections: your active suppliers at the top, and all available suppliers below. The search bar helps you find any supplier quickly.',
    howSuppliers2: 'Activate built-in suppliers',
    howSuppliers2d: 'Find the supplier you want (e.g., Walmart, Target, Amazon) and click the toggle switch to activate it. Once active, it will appear in the supplier dropdown when you create gift cards.',
    howSuppliers3: 'Create custom suppliers',
    howSuppliers3d: 'If your supplier isn\'t in the list, click "New Supplier" to create a custom one. Enter the name, website (optional), and default discount percentage. This discount will auto-fill when you add cards for this supplier.',
    howSuppliers4: 'Set a custom discount for your account',
    howSuppliers4d: 'For built-in suppliers, click the edit button and set "My Discount" — this overrides the system default for your account. For example, if Walmart\'s default is 9% but you consistently get 7%, set your custom discount to 7% and it will auto-fill every time.',
    howSuppliersTip: 'Custom discounts are shown with a yellow badge and an asterisk (*) in the suppliers list so you can easily tell which ones you\'ve customized. When you create a new gift card, your custom discount is used automatically instead of the system default.',

    // How To — Gift Cards
    howCards: 'How to manage Gift Cards',
    howCards1: 'Browse your cards',
    howCards1d: 'Click "Gift Cards" in the sidebar to see your full inventory. Use the filters at the top to narrow down by status (Active, Partial, Depleted), supplier, or search by card code/number. You can sort by any column.',
    howCards2: 'Add a new card (with smart auto-fill)',
    howCards2d: 'Click the "+" button to create a new card. If you have a supplier filter active, CardLockr will automatically fill in the supplier and discount for you — no need to select manually. You can also add multiple cards at once using the bulk entry mode.',
    howCards3: 'Use a card (record spending)',
    howCards3d: 'Click on any card to open its detail page, then click "Quick Use" to record how much you spent. The balance updates instantly, and the transaction is logged with the date, amount, and who made it. If the balance hits $0, the card is marked as "Depleted" automatically.',
    howCards4: 'Click to copy card number & PIN',
    howCards4d: 'Need to use a card online? Click directly on the card number in the table and it\'s copied to your clipboard instantly. For PINs: click once to reveal the hidden PIN, then click again to copy it. A quick toast notification confirms the copy.',
    howCards5: 'Track card status',
    howCards5d: 'Cards have automatic status tracking: Active (has full balance), Partial (some balance used), Depleted (balance is $0), Expired, or Cancelled. Status updates happen automatically when you record transactions.',
    howCardsTip: 'When you have a supplier filter active (e.g., showing only Boscovs cards) and click "+", the new card form auto-fills with that supplier and its discount rate — great for entering multiple cards from the same supplier quickly.',

    // How To — CSV Import
    howImport: 'How to import cards via CSV',
    howImp1: 'Prepare your CSV file',
    howImp1d: 'Go to Settings > Account & Import and click "Download Template" to get a blank CSV with the correct columns: supplier, site, buyer, value, discount, paid_value, balance, card_number, pin, purchase_order, purchase_date, expiration_date. Fill in your data using a spreadsheet app.',
    howImp2: 'Format your data correctly',
    howImp2d: 'Make sure: supplier names match exactly (e.g., "Walmart" not "walmart gift card"), values use numbers without currency symbols (200 not $200), dates are in DD/MM or DD/MM/YYYY format, and PINs are stored as text (not numbers) to preserve leading zeros like "0632".',
    howImp3: 'Upload and import',
    howImp3d: 'Click "Upload CSV" and select your file. CardLockr will process each row: matching suppliers, encrypting card data, checking for duplicate card numbers, and creating purchase transactions automatically. You\'ll see a summary showing how many cards were imported and any errors.',
    howImp4: 'Review the results',
    howImp4d: 'After import, check the Gift Cards page to verify everything looks correct. Each imported card has a purchase transaction auto-created. If any rows had errors (missing supplier, duplicate card number), they\'re listed in the import results so you can fix and re-import them.',
    howImpTip: 'Important: If you edit the CSV in Excel, be careful with PINs that start with 0 (like "0632"). Excel may strip the leading zero and save it as "632". To prevent this, format the PIN column as "Text" in Excel before entering data, or use Google Sheets which handles this better.',

    // How To — Transactions
    howTransactions: 'How to record Transactions',
    howTx1: 'View transaction history',
    howTx1d: 'Click "Transactions" in the sidebar to see a chronological list of all card movements. Each transaction shows the card code, type (Purchase, Usage, Adjustment, Return), amount, who did it, and the resulting balance.',
    howTx2: 'Record a new transaction',
    howTx2d: 'You can record transactions in two ways: (1) From the Transactions page, click "New Transaction" and select the card, type, and amount. (2) From a card\'s detail page, click "Quick Use" for the fastest path — just enter the amount and you\'re done.',
    howTx3: 'Filter and understand your activity',
    howTx3d: 'Use the filters at the top to find specific transactions by type, card, user, or date range. This is helpful for reconciling purchases or understanding usage patterns.',
    howTxTip: 'Every transaction is immutable — once recorded, it becomes part of the card\'s audit trail. If you make a mistake, create an Adjustment transaction to correct the balance rather than deleting.',

    // How To — Reports
    howReports: 'How to use Reports',
    howRep1: 'Analyze your portfolio',
    howRep1d: 'Go to "Reports" in the sidebar. The "By Supplier" tab shows total face value, amount invested, available balance, total savings, and average discount for each supplier. The "By Buyer" tab shows the same metrics grouped by who purchased the cards.',
    howRep2: 'Export your data',
    howRep2d: 'Click "Export CSV" to download a spreadsheet with all the data. This is useful for accounting, tax records, or sharing reports with team members who don\'t have CardLockr access.',
    howRepTip: 'Reports update in real-time. Check them regularly to identify which suppliers give you the best discounts and where most of your portfolio value is concentrated.',

    // How To — Team
    howUsers: 'How to manage your Team',
    howUsr1: 'View your team',
    howUsr1d: 'Click "Users" in the sidebar to see all team members, their roles, last login time, and how many cards each has created.',
    howUsr2: 'Invite new members',
    howUsr2d: 'Click "Invite User" and enter their name, email, and role (Admin or Operator). They\'ll receive an email with instructions to set up their account and choose a password. The invite link is valid for 7 days.',
    howUsr3: 'Understand roles',
    howUsr3d: 'Admins have full access: they can manage cards, transactions, suppliers, users, settings, and billing. Operators can manage cards and transactions but cannot invite users, change settings, or access billing — perfect for team members who just need to add/use cards.',
    howUsrTip: 'Each plan has a user limit (Free: 1, Starter: 3, Pro: unlimited). If you need more seats, upgrading is instant from Settings > Plan.',

    // How To — Security
    howSecurity: 'How to secure your Account',
    howSec1: 'Enable two-factor authentication (2FA)',
    howSec1d: 'Go to Settings > Security. By default, CardLockr sends a 6-digit code to your email every time you log in. For even stronger security, enable Google Authenticator (TOTP) — this generates codes on your phone that change every 30 seconds, so even if someone has your password, they can\'t log in without your phone.',
    howSec2: 'Monitor login activity',
    howSec2d: 'In Settings > Login History, you can see every login attempt on your account — including the IP address, browser, device, and whether it was successful. If you see a login you don\'t recognize, change your password immediately.',
    howSec3: 'Revoke suspicious sessions',
    howSec3d: 'Settings > Active Sessions shows all devices currently logged in. If you see an unfamiliar device, click "Revoke" to immediately log it out. You can also click "Revoke All" to log out every device except your current one.',
    howSecTip: 'CardLockr encrypts all card numbers and PINs with AES-256-CBC encryption at rest. Even if someone accessed the database directly, they could not read your card data without the encryption key.',

    // Features tab
    allFeatures: 'All Features',
    fDashTitle: 'Dashboard',
    fDashDesc: 'Real-time overview with total cards, portfolio value, total savings, and active balance. Includes charts showing card movement by supplier over time, plus a list of cards expiring soon.',
    fCardsTitle: 'Gift Cards',
    fCardsDesc: 'Complete card management with table view, filtering by status/supplier/buyer, search by code or card number, click-to-copy for card numbers and PINs, quick-use for fast spending, and automatic status tracking.',
    fSuppTitle: 'Suppliers',
    fSuppDesc: '30+ built-in suppliers with favicons. Create custom suppliers with your own discount rates. Set per-account custom discounts that override system defaults and auto-fill when creating cards.',
    fTxTitle: 'Transactions',
    fTxDesc: 'Record purchases, usage, adjustments, and returns. Full history with filters by type, card, and user. Every transaction updates the card balance automatically and is logged permanently.',
    fRepTitle: 'Reports',
    fRepDesc: 'Analytics by supplier and buyer. Track face value, invested amount, available balance, total savings, and average discount. Export everything to CSV for accounting.',
    fUsrTitle: 'Team Management',
    fUsrDesc: 'Invite users via email with Admin or Operator roles. Track activity per user. Plan-based user limits (Free: 1, Starter: 3, Pro: unlimited).',
    fSetTitle: 'Settings',
    fSetDesc: 'Plan management, password/email changes, timezone and language preferences, CSV import/export, purchase site management, and account deletion.',
    fSecTitle: 'Security',
    fSecDesc: 'AES-256-CBC encryption for card numbers and PINs at rest. Two-factor authentication (email OTP by default + optional TOTP via Google Authenticator). Login history and session management.',
    fImpTitle: 'CSV Import',
    fImpDesc: 'Bulk import gift cards from CSV files with automatic column mapping. Handles date formats, currency symbols, duplicate detection, and preserves PIN leading zeros. Available on Starter and Pro plans.',
    fPayTitle: 'Payments',
    fPayDesc: 'Stripe-powered billing with instant plan upgrades, invoice history, and automatic subscription management. Cancel anytime.',
    fCopyTitle: 'Click to Copy',
    fCopyDesc: 'Click any card number in the table to instantly copy it to your clipboard. Click a PIN to reveal it, then click again to copy. Quick toast notifications confirm every copy action.',
    fDiscTitle: 'Custom Discounts',
    fDiscDesc: 'Override the default discount for any supplier in your account. Your custom rate auto-fills when creating cards and shows with a yellow badge in the suppliers list.',
    fLangTitle: 'Multi-language',
    fLangDesc: 'Full interface available in English and Portuguese (Brazil). Switch languages instantly from Settings — all labels, dates, and currency formats update immediately.',

    // FAQ
    faqTitle: 'Frequently Asked Questions',
    faqs: [
      { q: 'Is my card data secure?', a: 'Absolutely. Security is our top priority. Here\'s how we protect your data:\n\n• Encryption at rest — Every card number and PIN is encrypted with AES-256-CBC before it touches the database. This is the same encryption standard used by banks and governments.\n\n• Never stored in plain text — We literally cannot see your card numbers or PINs. Even if our database were compromised, attackers would only find encrypted gibberish.\n\n• Two-factor authentication — Every login requires a verification code (email or Google Authenticator), so a stolen password alone isn\'t enough.\n\n• Tenant isolation — Your data is completely separated from other accounts. Every query is scoped to your account ID.\n\n• Login monitoring — You can see every login attempt in Settings, including IP, browser, and device, and revoke suspicious sessions instantly.\n\n• Rate limiting — Brute-force attacks are blocked automatically after too many failed attempts.' },
      { q: 'Can I share access with my team?', a: 'Yes! Go to Users and click "Invite User". You can assign Admin (full access) or Operator (cards + transactions only) roles. Each team member gets their own login and all activity is tracked per user.' },
      { q: 'How do I import existing cards?', a: 'Go to Settings > Account & Import and download the CSV template. Fill in your card data in a spreadsheet, then upload the CSV file. CardLockr will match suppliers, encrypt card data, detect duplicates, and create purchase transactions — all automatically.' },
      { q: 'What happens when I downgrade my plan?', a: 'Your card data is always preserved — we never delete your cards. However, users and custom suppliers beyond the new plan\'s limit will be deactivated. You can reactivate them by upgrading again.' },
      { q: 'Can I export my data?', a: 'Yes. The Reports page has "Export CSV" buttons for both supplier and buyer reports. You can also download a CSV template for backup or migration purposes.' },
      { q: 'How does two-factor authentication work?', a: 'By default, a 6-digit code is sent to your email every time you log in. For stronger security, you can enable Google Authenticator (TOTP) in Settings > Security — this uses your phone to generate time-based codes that change every 30 seconds.' },
      { q: 'What browsers are supported?', a: 'CardLockr works on all modern browsers: Chrome, Firefox, Safari, and Edge. It\'s also fully usable on mobile browsers — no app download needed.' },
      { q: 'How do I change my language?', a: 'Go to Settings > System and select your preferred language. CardLockr is available in English and Portuguese (Brazil). The change is instant — all labels, dates, and currency formats update immediately.' },
      { q: 'How do I copy a card number or PIN?', a: 'Just click on the card number in the Gift Cards table — it\'s copied to your clipboard instantly. For PINs: click once to reveal the hidden PIN, then click again to copy it. A toast notification confirms the copy.' },
      { q: 'What is the "My Discount" field in suppliers?', a: 'When you edit a built-in supplier, you can set a custom discount that overrides the system default for your account. For example, if Target\'s default discount is 11% but you consistently get 8%, set "My Discount" to 8% and it will auto-fill every time you add a Target card.' },
      { q: 'Why did my PIN lose a leading zero during import?', a: 'This usually happens when the CSV file is opened in Excel, which automatically converts text-looking numbers. To prevent this, format the PIN column as "Text" in Excel before entering data, or use Google Sheets instead. CardLockr preserves leading zeros during import as long as the CSV file has them.' },
      { q: 'Can I delete my account?', a: 'Yes. Go to Settings > Danger Zone and click "Delete Account". This will permanently delete all your data including cards, transactions, and user accounts. This action cannot be undone.' },
    ],

    // Shortcuts
    shortcutsTitle: 'Keyboard Shortcuts',
    scSearch: 'Open command palette / search',
    scSidebar: 'Toggle sidebar collapse',
    scClose: 'Close modals and panels',

    // Click actions
    clickActionsTitle: 'Click Actions',
    caCardNum: 'Click Card #',
    caCardNumDesc: 'Instantly copies the full card number to your clipboard',
    caPinHidden: 'Click PIN (hidden)',
    caPinHiddenDesc: 'Reveals the hidden PIN so you can see it',
    caPinRevealed: 'Click PIN (revealed)',
    caPinRevealedDesc: 'Copies the PIN to your clipboard',
  },

  // Trial banner
  trialBanner: ({ days }) => `Pro trial — ${days} day${days !== 1 ? 's' : ''} remaining`,
  upgrade: 'Upgrade',
  trialBannerExpired: 'Your Pro trial has ended',

  // Error Boundary
  errorBoundary: {
    title: 'Something went wrong',
    message: 'An unexpected error occurred. Please try reloading the page.',
    reload: 'Reload Page',
  },

  // Landing page
  landing: {
    trustedBy: 'Trusted by {count}+ businesses managing their gift cards',
    mostPopular: 'Most Popular',
    comparePlans: 'Compare plans',
    feature: 'Feature',
    giftCards: 'Gift Cards',
    suppliers: 'Suppliers',
    teamMembers: 'Team Members',
    transactionHistory: 'Transaction History',
    csvImport: 'CSV Import',
    pdfExport: 'PDF Export',
    reportsAnalytics: 'Reports & Analytics',
    twoFaTotp: '2FA (TOTP)',
    prioritySupport: 'Priority Support',
    unlimited: 'Unlimited',
    securedByStripe: 'Secured by Stripe',
    aesEncryption: '256-bit AES Encryption',
    gdprCompliant: 'GDPR Compliant',
    moneyBackGuarantee: '30-day money-back guarantee',
  },

  // Date format
  dateFormat: {
    short: 'MM/DD/YY',
    formatFn: (d, tz) => {
      if (!d) return '-';
      const date = new Date(d);
      if (tz) {
        try {
          const parts = new Intl.DateTimeFormat('en-US', {
            timeZone: tz, month: '2-digit', day: '2-digit', year: '2-digit',
          }).formatToParts(date);
          const get = (type) => (parts.find(p => p.type === type) || {}).value || '';
          return `${get('month')}/${get('day')}/${get('year')}`;
        } catch (e) { /* fallback below */ }
      }
      const mm = String(date.getMonth() + 1).padStart(2, '0');
      const dd = String(date.getDate()).padStart(2, '0');
      const yy = String(date.getFullYear()).slice(-2);
      return `${mm}/${dd}/${yy}`;
    },
    formatTimeFn: (d, tz) => {
      if (!d) return '-';
      const date = new Date(d);
      if (tz) {
        try {
          const parts = new Intl.DateTimeFormat('en-US', {
            timeZone: tz, month: '2-digit', day: '2-digit', year: '2-digit',
            hour: '2-digit', minute: '2-digit', hour12: false,
          }).formatToParts(date);
          const get = (type) => (parts.find(p => p.type === type) || {}).value || '';
          return `${get('month')}/${get('day')}/${get('year')} ${get('hour')}:${get('minute')}`;
        } catch (e) { /* fallback below */ }
      }
      const mm = String(date.getMonth() + 1).padStart(2, '0');
      const dd = String(date.getDate()).padStart(2, '0');
      const yy = String(date.getFullYear()).slice(-2);
      const hh = String(date.getHours()).padStart(2, '0');
      const min = String(date.getMinutes()).padStart(2, '0');
      return `${mm}/${dd}/${yy} ${hh}:${min}`;
    },
  },

  // Enterprise
  enterprise: {
    title: 'Enterprise',
    subtitle: 'For large teams with custom needs',
    customPricing: 'Custom',
    contactSales: 'Contact Sales',
    formTitle: 'Contact Sales',
    formSubtitle: 'Tell us about your needs and we\'ll tailor a plan for your team.',
    nameLabel: 'Name',
    emailLabel: 'Work Email',
    companyLabel: 'Company Name',
    teamSizeLabel: 'Team Size',
    monthlyVolumeLabel: 'Monthly Volume',
    messageLabel: 'Message (optional)',
    submit: 'Submit Inquiry',
    submitting: 'Submitting...',
    thankYou: 'Thank you!',
    thankYouMessage: 'We\'ve received your inquiry and will get back to you within 24 hours.',
    features: ['Everything in Pro', 'SSO (coming soon)', 'Dedicated support', 'Custom onboarding', 'Audit log API', 'Custom limits'],
  },

  // Blog
  blog: {
    blogTitle: 'CardLockr Blog',
    blogDescription: 'Expert tips on gift card tracking, discount optimization, and portfolio management.',
    readingTime: 'read',
    sharePost: 'Share this post',
    tryFree: 'Try CardLockr Free',
    writtenBy: 'By',
    relatedPosts: 'Related Posts',
    backToBlog: 'Back to Blog',
    read: 'read',
  },

  // Referrals
  referrals: {
    title: 'Referrals',
    yourReferralLink: 'Your Referral Link',
    copyLink: 'Copy Link',
    linkCopied: 'Referral link copied!',
    shareAndEarn: 'Share & Earn',
    referralDescription: 'Invite friends to CardLockr. When they sign up and subscribe, you both get 1 month free!',
    pending: 'Pending',
    qualified: 'Qualified',
    rewarded: 'Rewarded',
    totalReferrals: 'Total Referrals',
    linkClicks: 'Link Clicks',
    signups: 'Signups',
    rewardsEarned: 'Rewards Earned',
    customizeCode: 'Customize your code',
    howItWorks: 'How it works',
    step1: 'Share your unique referral link',
    step2: 'Friend signs up and upgrades to a paid plan',
    step3: 'You both get 1 month free!',
  },

  // Growth & Sharing
  growth: {
    shareReport: 'Share Report',
    generateLink: 'Generate Share Link',
    shareExpires: 'Expires in 30 days',
    noSensitiveData: 'No sensitive data shared: Card numbers, PINs, and personal emails are never included.',
    linkCopied: 'Share link copied!',
    milestoneReached: 'Milestone Reached!',
    shareAchievement: 'Share this achievement',
    exportBranding: 'Export Branding',
    brandingDescription: 'Controls whether "Generated by CardLockr" appears on your PDF and CSV exports.',
    showBranding: 'Show CardLockr branding on exports',
    brandingPaidOnly: 'Branding removal available on paid plans',
  },

  // Add-ons
  addons: {
    title: 'Add-ons',
    description: 'Extend your plan with extra capacity and features.',
    purchase: 'Purchase',
    cancel: 'Cancel',
    active: 'Active',
    availableOn: 'Available on',
    perMonth: '/mo',
  },

  // Newsletter
  newsletter: 'Newsletter',
  subscribeNewsletter: 'Subscribe to newsletter',
  newsletterDescription: 'Get gift card management tips weekly',
  checkEmailConfirm: 'Check your email to confirm!',
  alreadySubscribed: 'You are already subscribed!',
  confirmSubscription: 'Confirm Subscription',

  // Integrations & API
  integrations: 'Integrations',
  apiDocs: 'API Docs',
  apiDocumentation: 'API Documentation',
  webhooks: 'Webhooks',
  comingSoon: 'Coming Soon',
  joinWaitlist: 'Join Waitlist',
  available: 'Available',
  apiKeyManagement: 'API Key Management',
  generateApiKey: 'Generate API Key',
  revokeKey: 'Revoke Key',
  requestsToday: 'Requests Today',
  apiKeyWarning: 'Keep your API key secret. Treat it like a password.',

  // Dunning / Payment Issue
  paymentIssueBanner: 'Payment issue — your card was declined. Update your billing info to avoid service interruption.',
  updateBilling: 'Update Billing',
};

export default en;
